import { AsyncPipe, NgClass, NgFor, NgIf } from '@angular/common';
import { NgModule } from '@angular/core';
import { ProcessLinkModule, SafeHtmlPipe, SdvorButtonComponent } from '@sdvor/shared/ui';
import { IconModule } from '@spartacus/storefront';
import { SnackComponent } from './snack/snack.component';
import { SnackbarDirective } from './snackbar-ref.directive';
import { SnackbarTemplatesComponent } from './snackbar-templates/snackbar-templates.component';
import { SnackbarComponent } from './snackbar.component';

@NgModule({
  declarations: [SnackbarComponent, SnackComponent, SnackbarTemplatesComponent, SnackbarDirective],
  imports: [NgIf, NgFor, AsyncPipe, NgClass, SafeHtmlPipe, IconModule, ProcessLinkModule, SdvorButtonComponent],
  exports: [SnackbarComponent],
})
export class MainSnackbarUiModule {}
